module.exports = __webpack_public_path__ + "3225688853e2ec248157963db2771d63.png";